import { Typography } from '@deeptrue-frontend/ui';
import React from 'react';
import styled from 'styled-components/macro';

const Container = styled.div<{
  isVisible: boolean;
  position: string;
}>`
  z-index: 1;
  position: absolute;
  left: -0.2rem;
  top: ${({ position }) => (position === 'top' ? '1rem' : '3rem')};
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
`;

const TooltipContainer = styled.div`
  background-color: #e3e5e8;
  width: fit-content;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  display: flex;
  margin-left: -2rem;
`;
const Arrow = styled.div`
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 10px solid #e3e5e8;
`;

interface TooltipPropsType {
  title: string;
  subtitle: string;
  isVisible: boolean;
  position: string;
}

const Tooltip = ({
  title,
  subtitle,
  isVisible,
  position,
}: TooltipPropsType) => {
  return (
    <Container isVisible={isVisible} position={position}>
      <Arrow />
      <TooltipContainer>
        <Typography
          fontSize={'0.875rem'}
          fontWeight={'700'}
          mr={'0.25rem'}
          color={'#253858'}
        >
          {title}
        </Typography>
        <Typography fontSize={'0.875rem'} fontWeight={'400'} color={'#253858'}>
          {subtitle}
        </Typography>
      </TooltipContainer>
    </Container>
  );
};

export default Tooltip;
